<template>
  <div class="join">
    <div class="title"><img src="../assets/circle.png"><b>客户列表</b></div>
    <div class="searchDiv">
      <div class="searchDivLeft">
        <el-select class="selectValue" v-model="selectValue" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
        </el-select>
        <el-input v-model="keyword" :placeholder="placeholder"></el-input><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
    </div>
    <div class="joinList">
      <table class="activeTable" cellspacing="0" cellpadding="0">
        <tr><th width="8%">序号</th><th width="15%">小区+楼号+姓名</th><th width="15%">电话</th><th width="25%">地址</th><th width="10%">所属运维</th><th width="15%">创建时间</th><th width="10%">设备</th></tr>
        <tr v-for="(item,index) in joinList" :key="item.id">
          <td align="center">{{index+(cur-1)*10+1|cutserial}}</td>
          <td align="center"><span>{{item.trueName|cutstr(12)}}</span></td>
          <td align="center">{{item.phone}}</td>
          <td align="center"><span :title="item.address">{{item.address|cutstr(20)}}</span></td>
          <td align="center">{{item.devopsName}}</td>
          <td align="center"><span>{{item.createTime}}</span></td>
          <td align="center"><span class="view" @click="viewDetail(item.id)">查看</span></td>
        </tr>
      </table>
      <div class="nodata" v-if="showNodata"><img src="../assets/no_data.png"><p>暂无数据</p></div>
    </div>
    <div class="page" v-if="!showNodata"><page :currentPage=cur :total='total' :pageSize='pageSize' @pageNum="getPage"></page></div>
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
import {getCustomerList} from '@/api/api'
import bus from '@/bus'
import Page from '@/components/Page'
import {formatDate} from '@/api/common'
import EditType from '@/components/EditType'
import Loading from '@/components/Loading'
export default {
  name: 'device',
  data () {
    return {
      joinList:[],
      memberInfo:{},
      keyword:'',
      showNodata:false,
      showEditMember:false,
      showLoading:false,
      pageSize: 10, //每页几条
      cur: 1,//当前页码
      total:0 ,//总条数
      options: [{
                value: '按姓名',
                label: '按姓名'
              }, {
                value: '按电话',
                label: '按电话'
              }],
      selectValue: '按姓名',
      placeholder:'请输入姓名查询'
    }
  },
  mounted(){
    bus.$off('closeEditMember')
    bus.$on('closeEditMember',res=>{
      this.showEditMember=false
      this.getData()
    })
    this.getData()
  },
  methods:{
    search(){
      this.cur=1
      this.getData(this.keyword)
    },
    getData(key){
      if(this.selectValue=='按姓名'){
        var data=JSON.stringify({
            "trueName":key,
          	"pageSize": this.pageSize,
          	"currentPage": this.cur
        })
      }
      if(this.selectValue=='按电话'){
        var data=JSON.stringify({
            "phone":key,
          	"pageSize": this.pageSize,
          	"currentPage": this.cur
        })
      }
      this.showLoading=true
      getCustomerList(data).then(res=>{
        this.showLoading=false
        if(res.data.state==200){
          const {data}=res.data
          if(data==''||data==null){
            this.showNodata=true
          }else{
            this.showNodata=false
          }
          this.total=res.data.totalCount
          this.joinList=data
        }
      }).catch(err=>{
        this.showLoading=false
      })
    },
    getPage(data){
      this.cur=data
    },
    viewDetail(id){
      this.$router.push({path:'customerDevice',query:{id}})
    }
  },
  filters:{
    getTime(time) {
     var date = new Date(time);
     return formatDate(date, 'yyyy-MM-dd h:m:s').slice(0,16);
    },
    cutstr(val,len){
      if(val&&val.length>len){
        return val.slice(0,len)+'...'
      }else{
        return val
      }
    },
    cutserial(val){
       var len=val.toString().length
        if(len==1){
          return '00'+val
        }
        if(len==2){
          return '0'+val
        }
    }
  },
  watch:{
    cur(val){
      this.getData(this.keyword)
    },
    selectValue(val){
      if(val=='按姓名'){
        this.placeholder="请输入姓名查询"
      }
      if(val=='按电话'){
        this.placeholder="请输入电话查询"
      }
    }
  },
  components:{
    Page,
    EditType,
    Loading
  },
  // beforeRouteEnter(to,from,next) {
  //   var that=this
  //   var manager=localStorage.getItem('manager')
  //   if(manager=='M'){
  //     next()
  //   }else{
  //      alert('您没有访问权限')
  //      next('/login')
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .searchDiv {height:50px;line-height:50px;margin-top:20px;}
   .el-input {width:250px;margin-right:10px;}
   .joinList {height:500px;margin-top:20px;}
   .activeTable {width:100%;margin-top:5px;}
   .activeTable tr {height:40px;line-height:45px;}
   .activeTable tr input {width:16px;height:16px;position:relative;top:2px;}
   .activeTable tr th {font-weight: 100;background:#f6f6f6;}
   .activeTable tr td {border-bottom: #eee 1px solid;}
   .page {height:50px;}
   .searchDivLeft {width:500px;float: left;}
   .searchDivRight {width: 300px;text-align: right;float: right;}
   .options span {color:#fff;font-size:12px;padding:7px 10px;border-radius:4px;margin-left:5px;margin-right:5px;background:#409eff;cursor: pointer;}
   .addBn {float: right;}
   .view {color:#357af1;cursor: pointer;}
   .selectValue {width:100px;}
</style>



// WEBPACK FOOTER //
// src/views/CustomerList.vue